module.exports = [{
      plugin: require('/fargate/76efaba8/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Diff Ltd","short_name":"Diff","start_url":"/","background_color":"#E6E6FA","theme_color":"#E6E6FA","display":"minimal-ui","icon":"src/images/diff-compact-transp.png"},
    },{
      plugin: require('/fargate/76efaba8/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
